"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var StructPropBuilder_1 = require("../../core/model/data-dictionary/StructPropBuilder");

var DomainObject_1 = require("../../core/model/DomainObject");
/**
 * DTO object for a {@link WindowItem window item} promo price recalculated for a specific amount of {@link Product product}.
 * @author OPt
 */


var WindowItemPromoPriceDTO =
/*#__PURE__*/
function (_DomainObject_1$Domai) {
  _inherits(WindowItemPromoPriceDTO, _DomainObject_1$Domai);

  function WindowItemPromoPriceDTO(windowItemId, promoPrice) {
    var _this;

    _classCallCheck(this, WindowItemPromoPriceDTO);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(WindowItemPromoPriceDTO).call(this));
    _this.windowItemId = windowItemId;
    _this.promoPrice = promoPrice;
    return _this;
  }

  return WindowItemPromoPriceDTO;
}(DomainObject_1.DomainObject);

exports.WindowItemPromoPriceDTO = WindowItemPromoPriceDTO;

WindowItemPromoPriceDTO.schema = function () {
  var builder = new StructPropBuilder_1.StructPropBuilder(WindowItemPromoPriceDTO.name);
  return {
    windowItemId: builder.id('id'),
    promoPrice: builder.opt(builder.bigNum('promoPrice'))
  };
}();